<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">事故修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                             <el-col :span="24" class="item">
                                <el-form-item label="标题" required prop="title">
                                    <el-input v-model="editForm.title"  placeholder="请输入标题"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="描述" required prop="remarks">
                                    <Quill placeholder='请输入描述详情' v-model='editForm.remarks'  editorRef='editQuill' @input="handelIncrease"></Quill>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Quill from "@/components/Quill";
    export default {
        name: 'Edit',
        props: ["options"],
        data() {
            return {
                loading: false,
                imageUrl:"",
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    accidentRecordCode:'',
                    title:'',
                    remarks:''
                },
                rules:{
                    title:[
                        { required: true, message: '请输入标题', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入描述', trigger: 'blur' },
                    ]
                }

            }
        },
        components:{
            Quill
        },
        methods: {

            init(row){
                console.log(row);
                this.editForm.title = row.title;
                this.editForm.remarks = row.remarks;
                this.editForm.accidentRecordCode = row.accidentRecordCode;
            },
            handelIncrease(step) {
               this.editForm.remarks=step
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
             edit_bf2(file) {

                let fd = new FormData();
                fd.append('file',file);//传文件
                fd.append('staffCode',getStaffCode());//传其他参数
                fd.append('timeStr',timeStr);
                fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
                let that = this;
                this.$axios.post(this.$institutionUrl+'Upload/Imgs',fd).then(function(res){
                    console.log(res.data);

                    // 获取富文本组件实例
                    let quill = that.$refs.myQuillEditor.quill;

                    // 获取光标所在位置
                    let length = quill.selection.savedRange.index;

                    // 插入图片，res为服务器返回的图片链接地址
                    quill.insertEmbed(length, 'image', that.$imgUrl+res.data.data.path);

                    // 调整光标到最后
                    quill.setSelection(length + 1);

                })

            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                this.loading = true;

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"AccidentRecord/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("init");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
